import React from 'react';
import './TourItem.css';
import useAuth from '../../hooks/UseAuth'

const TourItem = (props) => {
    const {tour} = props;

    const {signInUsingGoogle} = useAuth();
    

    let totalQuantity = 0;
    let total = 0;
    for (const tours of tour) {
        if (!tours.quantity) {
            tours.quantity = 1;
        }
        total = total + tours.price * tours.quantity;
        totalQuantity = totalQuantity + tours.quantity;
    }

    const handleGoogleLogin = () =>{
        signInUsingGoogle()
        .then(result =>{
            alert('Your order is successfully')
        })
    }

    return (
        <div>
            <h2>Order Summary</h2>
            <h6>Order Items: {props.tour.length}</h6>
            <p>Total: ${total.toFixed(2)}</p>
            <button onClick={handleGoogleLogin} className="button">Confirm Your Order</button>
        </div>
    );
};

export default TourItem;